// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"e4ee9f27","107":"8394bc59","277":"e4ee9f27","423":"349cb0e0","493":"e4ee9f27","519":"c62d6856"}[chunkId] + ".chunk.css";
};